import cx from 'classnames'
import { useContext, useMemo } from 'react'

import { FrameBuilderSettingsContext } from '@frame-builder/contexts/settings-context'
import { FrameBuilderSelectedStateContext } from '@frame-builder/contexts/state-context'
import {
  getAllStepDefinitions,
  getFilteredStepDefinitions,
  getIsStepEnabled,
} from '@frame-builder/lib/steps'
import {
  FrameBuilderStep,
  FrameBuilderStepState,
} from '@frame-builder/lib/types'

interface DefinitionsProps {
  stepStates: Record<FrameBuilderStep, FrameBuilderStepState>
  onClose: () => void
  className?: string
}

const Definitions = ({ stepStates, onClose, className }: DefinitionsProps) => {
  const { selectedState } = useContext(FrameBuilderSelectedStateContext)
  const { frameBuilderConfiguration, frameBuilderType } = useContext(
    FrameBuilderSettingsContext,
  )

  const activeStepDefinitions = useMemo(() => {
    const allStepDefinitions = getAllStepDefinitions()
    const filteredStepDefinitions = getFilteredStepDefinitions(
      allStepDefinitions,
      (stepDefinition) => {
        return getIsStepEnabled(
          frameBuilderType,
          frameBuilderConfiguration,
          selectedState,
          stepDefinition.step,
        )
      },
    )

    return filteredStepDefinitions.filter(
      (stepDefinition) => stepStates[stepDefinition.step] !== 'closed',
    )
  }, [frameBuilderConfiguration, frameBuilderType, selectedState, stepStates])

  return (
    <div className={cx('w-full', className)}>
      {activeStepDefinitions.map((stepDefinition) => {
        const DefinitionComponent = stepDefinition.definitionComponent

        return (
          <DefinitionComponent
            key={stepDefinition.step}
            stepNumber={stepDefinition.stepNumber}
            onClose={onClose}
          />
        )
      })}
    </div>
  )
}

export default Definitions
